const tabs = {
  state: {
    // myGoodsTabs: 0, // 我的商品 tabs状态
    cmsConfigTabs: 0, // cms网站 -> 网站配置页
    cmmissionTabs: 0, // 分销设置 -> 佣金设置
    myCenterTabs: 0, // 个人中心
    moneyCenterTabs: 0, // 推币中心
    goodsListTabs: 0, // 放单审核 -> 商品列表
    financeTabs: 0, // 财务中心tab
    financeOrderTabs: 0, // 财务中心 -> 订单管理
    pluginLYGactive: 0, // 插件->零元购
    pluginTXHBactive: 0,  // 插件->提现红包
    pluginXSMSactive: 0,  // 插件->超级秒杀
    pluginFLJQRactive:0,  //插件->返利机器人
    pluginFLJQRrobot:0,  //插件->返利机器人类型
    pluginWxautoreplyactive:0,   //插件->返利机器人
    pluginAppManageactive:0, //插件导购app
    pluginAppHistory:0, //插件导购app，版本记录tab
    pluginAppAdminManageactive:0, //插件后台配置tab
  },

  mutations: {
    CHANGE_TABS: (state, { name, current }) => {
      state[name] = current
    },
    CACHE_TABS: (state) => {
      sessionStorage.setItem('tabs', JSON.stringify(state))
    },
    GET_CACHE_TABS: (state) => {
      let cache = sessionStorage.getItem('tabs')
      cache = JSON.parse(cache)
      Object.assign(state, cache)
    },
  },

  actions: {
    ChangeTabs: ({ commit }, { name, current }) => {
      commit('CHANGE_TABS', { name, current })
      commit('CACHE_TABS')
    },
    GetCacheTabs: ({ commit }) => {
      commit('GET_CACHE_TABS')
    },
  },
}

export default tabs